var AvailableCarriers;
(function (AvailableCarriers) {
  AvailableCarriers["YUNO"] = "yuno";
  AvailableCarriers["IUGU"] = "iugu";
  AvailableCarriers["MULTI"] = "multi";
})(AvailableCarriers || (AvailableCarriers = {}));

export { AvailableCarriers };
